import { enableApiHeaders, fetcher } from "../../../utils/Axios";
import { captureSentryApiError } from "../../../utils/Sentry";
import { REFRESH_ACCESS_TOKEN_REQUEST } from "../types/RequestTypes";
import { getAuthValue, updateAuthValue } from "./useAuthValue";
import { addSeconds } from "date-fns";
import { appReset } from "./useLogoutMutation";

async function refreshAccessToken() {
  const { refresh_token: refreshToken, realm, isLoggedIn } = getAuthValue();

  const reqBody: REFRESH_ACCESS_TOKEN_REQUEST = {
    refreshToken,
    realm,
  };
  return fetcher({
    url: "users/refresh/token",
    method: "POST",
    data: reqBody,
    authRequired: false,
    skipAuthRefresh: true,
  })
    .then((res) => {
      const {
        access_token,
        refresh_token,
        expires_in,
        refresh_expires_in,
        session_state,
      } = res?.data ?? {};

      const now = new Date();

      updateAuthValue({
        access_token,
        refresh_token,
        expires_in: addSeconds(now, expires_in).getTime(),
        refresh_expires_in: addSeconds(now, refresh_expires_in).getTime(),
        session_state,
      });

      enableApiHeaders();
      return res?.data;
    })
    .catch((error) => {
      captureSentryApiError(error);
      if (isLoggedIn) {
        appReset();
      }
    });
}

export default refreshAccessToken;
